<div [style.width.px]="width || 120" [style.height.px]="height || 120" class="wrapper hand" [ngClass]="{'float-left': floatLeft}">
    <img *ngIf="photoUrl; else noPhoto" [src]="photoUrl" alt="{{ firstName }} {{ lastName }}" />
    <ng-template #noPhoto>
        <div [style.width.px]="width || 120" [style.height.px]="height || 120" [style.line-height.px]="height || 120"
            class="circle-initials rounded-circle shadow text-center">
            {{ firstName[0] }}{{lastName && lastName.length > 0 ? (' ' + lastName[0]) : '' }}
        </div>
    </ng-template>
</div>
